import { render, staticRenderFns } from "./KeyValues.vue?vue&type=template&id=cb4d0908&"
import script from "./KeyValues.vue?vue&type=script&lang=js&"
export * from "./KeyValues.vue?vue&type=script&lang=js&"
import style0 from "./KeyValues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports